define('modules/campaigns/campaigns_helper',['backbone', 'jquery', '_'], function (Backbone, $, _) {
  'use strict';

  var that = this; //new line

  function everyItemInCollectionHasZone(collection, zoneCode) {

    if (!collection || !collection.models || !zoneCode) { return false; }

    // Work only on the models that are selected.
    var checkedModels = _.filter(collection.models, function(item) {
      return item.get('isChecked') === true;
    });

    var inEvery = _.every(checkedModels, function(item){

      if (item.get('zones')) {
        
        var zonesNames = _.map(item.get('zones'), function(z, idx, arra) {
          return z.zoneCode;
        });

        if (zonesNames.includes(zoneCode)) {
          return true;
        }
      }

      return false;
    }, that);

    return inEvery;
  }

  function everyItemInCollectionNotHaveZone(collection, zoneCode) {

    if (!collection || !collection.models || !zoneCode) { return false; }

    // Work only on the models that are selected.
    var checkedModels = _.filter(collection.models, function(item) {
      return item.get('isChecked') === true;
    });

    var inEvery = _.every(checkedModels, function(item){

      if (item.get('zones')) {
        
        var zonesNames = _.map(item.get('zones'), function(z, idx, array) {
          return z.zoneCode;
        });

        if (!zonesNames.includes(zoneCode)) {
          return true;
        }
      }

      return false;
    }, that);

    return inEvery;
  }

  return {
    everyItemInCollectionHasZone: everyItemInCollectionHasZone,
    everyItemInCollectionNotHaveZone: everyItemInCollectionNotHaveZone
  };
});

